import React from "react";
import styled from "styled-components";

const Label = styled.label`
  display: inline-block;
  margin: 1em 1em 0 0;
`;

const Textfield = styled.input`
  border: 1px solid #232323;
  padding: 1em 3em;
  font-size: 1em;
  width: calc(100% - 6em);
  &.error {
    border-color: #f00;
    color: #f00;
  }
`;

const ErrorMessage = styled.p`
  padding: 0.5em 3em;
  border: 1px solid #f00;
  background-color: rgba(255, 0, 0, 0.25);
`;

const Input = ({ name, label, value, onChange, errors }) => (
  <React.Fragment>
    <Label htmlFor={name}>{label}</Label>
    <Textfield
      className={errors ? "error" : null}
      type="text"
      id={name}
      value={value}
      onChange={onChange}
    />
    {errors && <ErrorMessage>{errors}</ErrorMessage>}
  </React.Fragment>
);

export default Input;



// WEBPACK FOOTER //
// ./src/Input.js